<template>
    <App title="Station Pricing Management">
	<div class="station-pricing-page">
		<!-- Header Section -->
		<div class="page-header mb-4">
			<div class="d-flex justify-content-between align-items-center">
				<div>
					<h4 class="fw-semibold mb-1">Station Pricing Management</h4>
					<p class="text-muted small mb-0">Udate battery pricing record  for stations</p>
				</div>
			
			</div>
		</div>

		<!-- Add Pricing Form -->
		<transition name="fade">
			<div class="mb-4">
				<div class="card border-0 shadow-sm">
					<div class="card-header bg-white border-0 py-3">
						<h6 class="mb-0 fw-semibold">Update Pricing Record</h6>
					</div>
					<div class="card-body">
						<PriceForm
							:url="route('price.ajax.update',{price:price.id})"
							:stations="stations"
							:battery-types="orderTypes"
                            :update-form="true"
                            :price-data="price"
							@success="handlePricingSuccess"
							@error="handlePricingError"
							@cancel="goBack"
						/>
					</div>
				</div>
			</div>
		</transition>

		<!-- Pricing List -->
		<div class="pricing-list">
			<!--
			<div v-if="pricings.length === 0" class="text-center py-5">
				<i class="fas fa-inbox fa-3x text-muted mb-3"></i>
				<p class="text-muted">No pricing configured yet</p>
			</div>
			-->

			<div class="row g-3">

                <!-- Pricing Datatable -->
				
				
			</div>
		</div>
	</div>
    </App>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from 'vue-facing-decorator'
import PriceForm from '@/vue/components/PriceForm.vue'
import App from '@/vue/templates/App.vue'
import Datatable from '@/vue/components/Datatable.vue'
import { CellRender, Column } from '@/vue/utils/Datatable'
import Swal from 'sweetalert2'

interface Station {
	value: string
	name: string
}

interface orderType {
	value: string
	name: string
}

interface Pricing {
	id: string
	station: string
	batteryType: string
	amount: number
	activatedAt: string

}

@Component({
	components: {
		PriceForm,
        App,
        Datatable
	}
})
class Pricing extends Vue {



	@Prop({ type: Array, default: () => [] })
	readonly stations!: Station[]

	@Prop({ type: Array, default: () => [] })
	readonly orderTypes!: orderType[]
    @Prop ({type:Object})
    readonly price!:any

	showAddForm = false
	pricings: Pricing[] = []

	


	handlePricingSuccess(event: any) {
		this.showToast(event.message, 'success')
		this.showAddForm = false
        this.router.visit(this.route('price.page.group'))
		
	}

	handlePricingError(event: any) {
		this.showToast(event.message, 'error')
	}



	formatCurrency(amount: number): string {
		return new Intl.NumberFormat('en-NG', {
			style: 'currency',
			currency: 'NGN',
			minimumFractionDigits: 0
		}).format(amount / 100)
	}

	formatDate(date: string): string {
		return new Date(date).toLocaleDateString('en-NG', {
			year: 'numeric',
			month: 'short',
			day: 'numeric'
		})
	}


	goBack() {
		window.history.back()
	}

	showToast(message: string, type: 'success' | 'error' ) {
        
        Swal.fire({
            toast: true,
            position: 'top-end', 
            icon: type, 
            title: message,
            showConfirmButton: false, 
            timer: 3000, 
            timerProgressBar: true,
            didOpen: (toast) => {
                // Pause the timer when the mouse hovers over the toast
                toast.addEventListener('mouseenter', Swal.stopTimer)
                // Resume the timer when the mouse leaves
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        })
    }



}

export default toNative(Pricing)
</script>

<style scoped>
.station-pricing-page {
	padding: 1.5rem;
	max-width: 1400px;
	margin: 0 auto;
}

.page-header h4 {
	color: #212529;
	font-size: 1.5rem;
}

.pricing-card {
	transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.pricing-card:hover {
	transform: translateY(-2px);
	box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1) !important;
}

.badge {
	font-weight: 500;
	padding: 0.35rem 0.65rem;
}

.bg-light {
	background-color: #f8f9fa !important;
}

.bg-success-subtle {
	background-color: #d1e7dd !important;
}

.text-success {
	color: #0f5132 !important;
}

.form-check-input:checked {
	background-color: #212529;
	border-color: #212529;
}

.form-check-input:focus {
	border-color: #212529;
	box-shadow: 0 0 0 0.25rem rgba(33, 37, 41, 0.25);
}

.discount-config .input-group-text {
	background-color: #f8f9fa;
	border-color: #dee2e6;
}

.discount-config .btn-dark {
	padding: 0.25rem 0.75rem;
}

/* Transitions */
.fade-enter-active, .fade-leave-active {
	transition: opacity 0.3s ease;
}

.fade-enter-from, .fade-leave-to {
	opacity: 0;
}

.slide-down-enter-active, .slide-down-leave-active {
	transition: all 0.3s ease;
	max-height: 100px;
	overflow: hidden;
}

.slide-down-enter-from, .slide-down-leave-to {
	max-height: 0;
	opacity: 0;
}

/* Responsive */
@media (max-width: 768px) {
	.station-pricing-page {
		padding: 1rem;
	}

	.page-header h4 {
		font-size: 1.25rem;
	}
}
</style>